module.exports = __webpack_public_path__ + "img/oralTest_sub32_1.041fa64f.jpg";